import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=fb329336&lang=pug"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports